import { useCallback } from 'react';
import { ImageBackground, Text } from 'react-native';
import { Flex, Typography, ColorValues } from '@banhala/ui-kit';
import type { NeonSignBoardProps } from './types';
import { bridge, isNil } from '../../../../utils';

export const NeonSignBoard = ({ entity }: NeonSignBoardProps) => {
  const firstEntity = entity?.[0];

  const handlePress = useCallback(() => {
    if (firstEntity?.item.deeplink) {
      bridge.openDeeplink(firstEntity.item.deeplink);
      bridge.logAnalyticsEvent({
        name: 'CLICK_NEON_SIGN_BOARD',
        analytics: firstEntity.logging.analytics,
        ably_only_log: firstEntity.logging.ably_only_log,
      });
    }
  }, [firstEntity]);

  if (isNil(entity) || entity.length === 0) {
    return null;
  }

  const { item } = entity[0];
  const { title, id, background_image, deeplink } = item;

  return (
    <Flex onPress={handlePress} disabled={!deeplink}>
      <ImageBackground
        source={{ uri: background_image }}
        style={{
          backgroundColor: ColorValues.gray70,
        }}
        resizeMode="cover"
      >
        <Flex.Row
          padding={{ vertical: 12, horizontal: 16 }}
          alignItems="center"
          gap={12}
        >
          <Flex flex={1}>
            {/* Text 사용: textShadow로 빛번짐(네온) 효과 구현 - Typography는 textShadow 미지원 */}
            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              style={{
                fontSize: 14,
                fontWeight: '600',
                color: ColorValues.white,
                textShadowColor: 'rgba(255, 255, 255, 0.8)',
                textShadowOffset: { width: 0, height: 0 },
                textShadowRadius: 10,
              }}
            >
              {title}
            </Text>
          </Flex>
          <Typography type="body4" color="content_disabled">
            {id}
          </Typography>
        </Flex.Row>
      </ImageBackground>
    </Flex>
  );
};
